// src/components/DynamicPageTitle.jsx
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

function DynamicPageTitle() {
  const location = useLocation();
  const { salonId } = useParams();

  useEffect(() => {
    let pageTitle = 'BespokeBeauty Salon';

    // Specific titles for different routes
    if (location.pathname.startsWith('/salon/')) {
      // Customer-specific routes
      if (location.pathname.includes('/dashboard')) {
        pageTitle += ' Customer Dashboard';
      } else if (location.pathname.includes('/login')) {
        pageTitle += ' Customer Login';
      } else if (location.pathname.includes('/complete-profile')) {
        pageTitle += ' Customer Profile Completion';
      } else if (location.pathname.includes('/appointments')) {
        pageTitle += ' Customer Appointments';
      } else if (location.pathname.includes('/book')) {
        pageTitle += ' Customer Booking';
      }
    } else {
      // Salon Admin routes
      if (location.pathname === '/login') {
        pageTitle += ' Admin Login';
      } else if (location.pathname === '/admin') {
        pageTitle += ' Admin Interface';
      }
    }

    document.title = pageTitle;
  }, [location.pathname, salonId]);

  return null;
}

export default DynamicPageTitle;